// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__tGWR1","section-1":"Federal_section-1__+h0bG","content":"Federal_content__DB6My","ul":"Federal_ul__CiZFY","section-2":"Federal_section-2__YEX1Y"};